export default __webpack_public_path__ + "static/media/art-3-seed-starting-2.78f08060.jpg";